<!-- 
  @component

  ## Basic usage:
  ***
      <Btn on:click={something}>Content</Btn>
  ***
  ## Props:
  ***
  - type: **primary** | secondary | danger | mute
  - size: sm | **md** | lg | xl
  - shadow: none | **sm** | md | lg | xl
  - shadowHover: none | sm | **md** | lg | xl
  - shadowActive: **none** | sm | md | lg | xl
 -->

<script>
  export let load = false,
    long = false,
    loading = false,
    tabindex = 0,
    secondary = false,
    spaced = false,
    lighter = false,
    disabled = false,
    hold = false,
    link = false,
    cta = false,
    dheight = false,
		gray = false,
    purple = false,
		small = false,
		submit = false,
    square = false,
    warn = false,
    icon = false,
    external = false,
    tool = 'hide'

  $: primary = !secondary && !gray && !warn && !purple
</script>

{#if link}
  <a
    on:click
    href={link}
    class:primary
    class:gray
    class:secondary
    class:loading
    class:spaced
    class:hold
    class:cta
    class:long
		class:dheight
		class:small
    class:warn
    class:square
    class:icon
    class:purple
    class:lighter
    target={external? '_blank' : ''}
    rel={external? 'noreferrer noopener' : ''}
		class="no-hl"
    {tabindex}>
    <slot />
  </a>
{:else}
  <button
    on:click
    class:primary
    class:gray
    class:secondary
    class:loading
    class:spaced
    class:disabled
    class:hold
    class:small
    class:warn
    class:dheight
    class:square
    class:icon
    class:purple
		aria-disabled={disabled}
		type={submit? 'submit' : 'button'}
    class="no-hl {tool}"
    data-link={load}
    {tabindex}>
    <slot />
  </button>
{/if}

<style>
  button,
  a {
    padding: 1.05rem 1.45rem;
    border-radius: 0.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    border: 0;
    text-align: center;
    line-height: inherit;
    text-decoration: none;
    text-transform: lowercase;
    transition: background-color 0.2s ease;
    cursor: pointer;
    margin: 0;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    font-family: "Karla", sans-serif;
    letter-spacing: 0.05rem;
    position: relative;
  }
  .gray {
    background-color: #e8e6e7;
  }
  .gray:hover,
  .gray:focus {
    background-color: #f1f1f1;
  }
  .gray:active {
    background-color: #e5e3e4;
  }
  .primary {
    background-color: #87e5fa;
    color: #171a1b;
  }
  .primary:hover,
  .primary:focus {
    background-color: #a9ebfa;
  }
  .primary:active {
    background-color: #58cfeb;
  }
  .lighter {
    background-color: #ccf6ff;
    color: #171a1b;
  }
  .lighter:hover,
  .lighter:focus {
    background-color: #ccf6ff;
  }
  .lighter:active {
    background-color: #ccf6ff;
  }
  .secondary {
    background-color: #ffb961;
    color: #171a1b;
  }
  .secondary:hover,
  .secondary:focus {
    background-color: #fec988;
  }
  .secondary:active {
    background-color: #f6b86b;
  }
  .warn {
    background-color: rgb(234 230 230);
    color: #171a1b;
    font-size: .9rem;
  }
  .warn:hover,
  .warn:focus {
    background-color: #fcbaa9;
  }
  .warn:active {
    background-color: #f19f8a;
  }
  .purple {
    background-color: #db90d1;
    color: #171a1b;
  }
  .purple:hover,
  .purple:focus {
    background-color: #e69edc;
  }
  .purple:active {
    background-color: #c57cbb;
  }
  .spaced {
    margin-right: 1rem;
  }

  .disabled,
  .disabled:hover,
  .disabled:active {
    background-color: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.54);
    cursor: default;
  }
  .disabled:focus {
    background-color: rgba(0, 0, 0, 0.05);
    box-shadow: 0 0 0 0.05rem rgba(132, 162, 169, 0.5);
  }
  .hold {
    min-width: 150px;
  }
  .hide:after, .hide:before {
    display: none
  }
  .cta {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  .dheight {
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loading {
    color: transparent;
	}
	.small {
		display: block;
    padding: .75rem 1rem;
    margin-bottom: 0;
    text-align: left;
    width: auto;
	}
  :global(iframe) {
    opacity: 0;
    position: absolute;
    z-index: -999;
    user-select: none;
    pointer-events: none;
    display: none;
  }
  .square {
    border-radius: 0;
  }
  .icon {
    width: auto;
    display: flex;
    align-items: center;
    gap: .5rem;
  }
  @media (max-width: 480px) {
    .long {
      display: block;
      margin: 0 10px;
      padding: 1rem 0;
    }
  }
</style>
